import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CommonButton from '@src/new-components/Button';
import CommonDialog from '@src/new-components/Dialog/CommonDialog';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { StyledUpdateAppActiveStatusDialogAction } from './index.style';

const UpdateAppActiveStatus = ({
  active,
  onUpdateAppStatus,
  actionLoading,
  open,
  onOpen,
  onClose,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  const handleUpdateAppStatus = async () => {
    await onUpdateAppStatus({ active: !active });
  };

  const renderDialogAction = () => (
    <StyledUpdateAppActiveStatusDialogAction>
      <div className="button-1">
        <CommonButton
          variant="outlined"
          onClick={onClose}
          customStyle={{
            height: '40px',
            padding: '8px 16px',
            borderRadius: '8px',
          }}
          disabled={actionLoading}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.label2[100],
          }}
        >
          {active
            ? t('cancelDeactiveApiAppAction')
            : t('cancelActivateApiAppAction')}
        </CommonButton>
      </div>
      <div className="button-1">
        <CommonButton
          variant={active ? 'containedDelete' : 'contained'}
          onClick={handleUpdateAppStatus}
          disabled={actionLoading}
          customStyle={{
            height: '40px',
            padding: '8px 16px',
            borderRadius: '8px',
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: active ? COLOR.white : COLOR.darkBlue,
          }}
        >
          {active
            ? t('confirmDeactiveApiAppAction')
            : t('confirmActivateApiAppAction')}
        </CommonButton>
      </div>
    </StyledUpdateAppActiveStatusDialogAction>
  );

  return (
    <>
      <div>
        {active ? (
          <CommonButton
            variant="containedDelete"
            onClick={onOpen}
            customStyle={{
              height: '40px',
              borderRadius: '8px',
              padding: '8px 16px',
            }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.white,
            }}
          >
            {t('deactivateApiApp')}
          </CommonButton>
        ) : (
          <CommonButton
            variant="contained"
            onClick={onOpen}
            customStyle={{
              height: '40px',
              borderRadius: '8px',
              padding: '8px 16px',
            }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.darkBlue,
            }}
          >
            {t('activateApiApp')}
          </CommonButton>
        )}
      </div>
      <CommonDialog
        width={isMobile ? '343px' : '512px'}
        open={open}
        onClose={onClose}
        contentComponent={
          isMobile ? (
            <Typography variant="body-14-regular" color={COLOR.darkGray}>
              {active
                ? t('confirmDeactivateApiApp')
                : t('confirmActivateApiApp')}
            </Typography>
          ) : (
            <Typography variant="body-16-regular" color={COLOR.darkGray}>
              {active
                ? t('confirmDeactivateApiApp')
                : t('confirmActivateApiApp')}
            </Typography>
          )
        }
        actionComponent={renderDialogAction()}
        renderTitle={
          isMobile ? (
            <Typography variant="body-16-bold" color={COLOR.darkGray}>
              {active
                ? t('confirmDeactiveApiAppAction')
                : t('confirmActivateApiAppAction')}
            </Typography>
          ) : (
            <Typography variant="body-20-bold" color={COLOR.darkGray}>
              {active
                ? t('confirmDeactiveApiAppAction')
                : t('confirmActivateApiAppAction')}
            </Typography>
          )
        }
        sx={
          isMobile
            ? {
                '& .MuiDialog-paper': {
                  minWidth: '343px !important',
                },
                '& .MuiDialogContent-root': {
                  padding: '16px !important',
                },
                '& .MuiDialogActions-root': {
                  padding: '12px 16px !important',
                },
                '& .MuiDialogTitle-root': {
                  height: '48px !important',
                  padding: '12px 16px !important',
                },
              }
            : {}
        }
      />
    </>
  );
};

export default UpdateAppActiveStatus;
